import Image from "next/image";
import React from "react";

const whyCooseCards = [
  {
    image:
      "https://ik.imagekit.io/mileseducation/miles_website/seo-pages/cma-course/favourite_cma_instructor.webp?updatedAt=1787558993900",
    title: "Learn from the World’s Favourite CPA Instructor",
    description:
      "Engage with Varun Jain, CPA, CMA, Harvard B-School Alumnus who has empowered 70K+ students to become the flag bearers of Indian accounting talent globally.",
  },
  {
    image:
      "https://ik.imagekit.io/mileseducation/miles_website/seo-pages/cma-course/global.webp",
    title: "CPA Study Guide: The CPA Books",
    description:
      "Learn from a vast network of industry leaders to deepen your understanding of core accounting and advanced AI workflows.",
  },
  {
    image:
      "https://ik.imagekit.io/mileseducation/miles_website/seo-pages/cma-course/cma-book.webp",
    title: "CPA Study Guide: The CPA Books",
    descriptionItems: [
      { label: "FAR", text: " (Financial Accounting & Reporting)" },
      { label: "AUD", text: " (Auditing & Attestation)" },
      { label: "REG", text: " (Taxation & Regulation)" },
      { label: "BAR", text: " (Business Analysis & Reporting)" },
    ],
    descriptionFooter: "and more…",
  },
  {
    image:
      "https://ik.imagekit.io/mileseducation/miles_website/seo-pages/cma-course/toolkit.webp?updatedAt=1787558994246",
    title: "Ultimate Resource Tool Kit!",
    description:
      "Get everything you need for your course via the Miles One App, including video lectures, MCQs, simulations, mock exams, one-on-one mentoring, and more.",
  },
  {
    image:
      "https://ik.imagekit.io/mileseducation/miles_website/seo-pages/cma-course/learning.webp",
    title: "Free Masterclass Subscription after CPA",
    description:
      "Earn free CPEs from Miles Masterclass conducted by global faculty for 3 years after receiving your license (worth $1,200).",
  },
  {
    image:
      "https://ik.imagekit.io/mileseducation/miles_website/seo-pages/cma-course/support.webp?updatedAt=1787558994391",
    title: "End-to-End License Support",
    description:
      "One-on-one guidance by the Gameplan Team for CPA eligibility checks, state board selection, international evaluation, NTS generation, Prometric scheduling, and final licensing.",
  },
];

const MilesCPAWhyChooseMiles = () => {
  return (
    <>
      <section className="w-full bg-white md:py-12 max-md:bg-[#F3F3F3] py-6">
        <div className="main_container">
          <div className="max-md:bg-white max-md:rounded-2xl max-md:px-4 max-md:py-4">
            {/* Section Heading */}
            <h2 className="md:text-[32px] text-[24px] font-bold text-left md:text-center leading-normal tracking-[-0.42px] md:mb-8 mb-3">
              <span className="text-[#333]">Why Choose </span>
              <span className="text-[#39F]">Miles CPA?</span>
            </h2>
            <p className="text-sm text-[#333] max-w-[900px] mx-auto md:text-center">
              Build your CPA journey with Miles Education, the institution
              helping shape the global finance ecosystem in India. With Miles
              CPA, you don't just get lectures; you get world-class coaching,
              expert mentorship, and a powerful alumni network built for
              long-term career success.
            </p>
            {/* Why Miles — scrollable row on mobile, 3-column grid on desktop */}
            <div className="flex md:grid md:grid-cols-3 md:gap-6 gap-3 max-w-[1100px] md:mx-auto md:mt-8 max-md:-mx-4 max-md:px-4 max-md:py-4 max-md:scroll-px-4 max-md:mt-1 max-md:overflow-x-auto max-md:snap-x max-md:snap-mandatory max-md:[scrollbar-width:none]">
              {whyCooseCards?.map((card) => (
                <div
                  key={card.title}
                  className="flex flex-col overflow-hidden rounded-[12px] [background:linear-gradient(180deg,rgba(255,255,255,0.00)_0%,rgba(255,255,255,0.20)_100%),#FFF] shadow-[0_0_30px_0_rgba(0,0,0,0.10)] md:w-full w-[260px] max-md:shrink-0 max-md:snap-start"
                >
                  <Image
                    src={card.image}
                    alt={card.title}
                    width={700}
                    height={420}
                    sizes="(max-width: 767px) 190px, 360px"
                    className="block w-full h-[155px] md:h-[210px]"
                    loading="lazy"
                  />
                  <div className="md:p-4 p-3">
                    <h3 className="text-[#3A73AC] md:text-base text-base font-semibold leading-[24px]">
                      {card.title}
                    </h3>
                    {card.descriptionItems ? (
                      <div className="text-[#333] text-sm font-normal leading-[22.75px] md:mt-3 mt-2">
                        {card.descriptionItems.map((item) => (
                          <p key={item.label}>
                            <span className="font-bold">{item.label}</span>
                            {item.text}
                          </p>
                        ))}
                        {card.descriptionFooter && (
                          <p>{card.descriptionFooter}</p>
                        )}
                      </div>
                    ) : (
                      <p className="text-[#333] text-sm font-normal leading-[22.75px] md:mt-3 mt-2">
                        {card.description}
                      </p>
                    )}
                  </div>
                </div>
              ))}
            </div>

            <div className="md:hidden mt-2 flex justify-center">
              <Image
                src="https://ik.imagekit.io/mileseducation/miles_website/accounting/cma-fees/%E2%86%90%20Swipe%20to%20explore%20%E2%86%921.webp"
                alt="Swipe to explore"
                width={160}
                height={20}
                className="h-auto w-[150px]"
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default MilesCPAWhyChooseMiles;
